import React, { useEffect, useState } from 'react'
import { Button, Input, Radio, Select } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { MenuWrapper, SearchWrapper, WhiteWrapper } from './segment.styled'
import useParams from '../../hook/useParams'
import Criteria from './Criteria/Criteria'
import SegmentList from './Segment/Segment'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { fetchBrandList } from '../../apis/brand'
import { fetchGroupList } from '../../apis/group'

function Segment (props) {
  const { viewOnly, adminMode } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { state, pathname } = location || {}
  const { type = 'criteria', prevViewOnly } = state || {}
  const user = useSelector((state) => state.user)
  const { nowBrand, nowGroup } = user || {}
  const [selectedGroup, setSelectedGroup] = useState('all')
  const viewOnlyDefParams = { brandId: undefined, 'brand.groupId': adminMode ? {} : selectedGroup === 'all' ? nowGroup : undefined }

  const params = useParams({
    includes: 'creator,dataSourceType,brand',
    ...(adminMode ? {} : { brandId: nowBrand, groupId: type === 'criteria' ? undefined : nowGroup, 'brand.groupId': type === 'segment' ? undefined : nowGroup }),
    ...viewOnly ? viewOnlyDefParams : {}
  })
  const { handleFetchParams, fetchParams } = params
  const [searchVal, setSearchVal] = useState()
  const [brands, setBrands] = useState([])
  const [groupList, setGroupList] = useState([])

  const menu = [
    { value: 'criteria', label: ln_t('segment.criteria') },
    { value: 'segment', label: ln_t('segment.segment') }
  ]
  const capitalized = str => str?.charAt(0)?.toUpperCase() + str?.slice(1)
  const formatDate = (date, detail) => dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')

  const passProps = { params, capitalized, formatDate, viewOnly }

  const table = {
    criteria: <Criteria {...passProps} />,
    segment: <SegmentList {...passProps} />
  }

  const resetParams = (nowType = type) => {
    const extraParams = adminMode
      ? { groupId: undefined, 'brand.groupId': undefined, [nowType === 'criteria' ? 'groupId' : 'brand.groupId']: fetchParams[nowType === 'criteria' ? 'brand.groupId' : 'groupId'] }
      : !viewOnly
          ? {
              groupId: nowType === 'criteria' ? undefined : nowGroup,
              brandId: nowBrand,
              'brand.groupId': nowType === 'segment' ? undefined : nowGroup
            }
          : {
              groupId: nowType === 'criteria' ? undefined : nowGroup,
              brandId: selectedGroup === 'all' ? undefined : selectedGroup,
              'brand.groupId': nowType === 'segment' ? undefined : nowGroup
            }
    handleFetchParams('add', { name_like: '%%', name: undefined, ...extraParams })
  }

  const handleChangeTab = e => {
    setSearchVal()
    resetParams(e?.target?.value)
    navigate('', { state: { type: e.target.value } })
  }

  const getBrands = async () => {
    const res = await fetchBrandList({ maxResults: 999, groupId: nowGroup })
    if (res?.status === 200) setBrands(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }
  const getGroups = async () => {
    const res = await fetchGroupList({ maxResults: 999 })
    if (res?.status === 200) setGroupList(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }

  useEffect(() => {
    setSearchVal()
    handleFetchParams('init')
    if (adminMode) getGroups()
    if (viewOnly && !adminMode) getBrands()
    if (viewOnly !== prevViewOnly) navigate('', { state: { type: 'criteria', prevViewOnly: viewOnly } })
  }, [viewOnly])

  useEffect(() => {
    const refetch = (nowBrand && nowBrand !== 0 && nowBrand !== fetchParams.brandId)
    if (refetch) resetParams()
  }, [nowBrand])

  return (
    <div>
        <MenuWrapper>
          <Radio.Group
            buttonStyle="solid"
            value={type}
            onChange={e => handleChangeTab(e)}
            options={menu}
            optionType="button"
          />
        </MenuWrapper>
        <WhiteWrapper>
          <h3>{ln_t(`segment.${type}`)}</h3>
          <SearchWrapper>
            <Input.Search
              allowClear
              style={{ width: '400px' }}
              placeholder={ln_t('util.search')}
              value={searchVal}
              onChange={e => setSearchVal(e?.target?.value)}
              onSearch={e => handleFetchParams('add', { [type === 'criteria' ? 'name_like' : 'name']: `%${e}%` })}
              enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
            />
            {viewOnly
              ? adminMode
                ? <div className="d-flex">
                    <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.group')} :</div>
                    <Select
                      showSearch
                      style={{ minWidth: '120px' }}
                      value={selectedGroup}
                      placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
                      options={[{ value: 'all', label: 'ALL' }, ...groupList]}
                      optionFilterProp="children"
                      onChange={e => {
                        setSelectedGroup(e)
                        handleFetchParams('add', { [type === 'criteria' ? 'brand.groupId' : 'groupId']: e === 'all' ? nowGroup : e })
                      }}
                    />
                  </div>
                : <div className="d-flex">
                    <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.brand')} :</div>
                    <Select
                      showSearch
                      style={{ minWidth: '120px' }}
                      defaultValue="all"
                      value={selectedGroup}
                      placeholder={`${ln_t('util.select')} ${ln_t('util.brand')}`}
                      options={[{ value: 'all', label: 'ALL' }, ...brands]}
                      optionFilterProp="children"
                      onChange={e => {
                        setSelectedGroup(e)
                        handleFetchParams('add', { brandId: e === 'all' ? undefined : e, 'brand.groupId': type === 'criteria' ? nowGroup : undefined, groupId: type === 'criteria' ? undefined : nowGroup })
                      }}
                    />
                  </div>
              : <Button type="default" icon={<PlusOutlined />} onClick={() => navigate(`${type === 'segment' ? '' : pathname}/${type}/new`)}>
                  {ln_t('util.add')} {ln_t(`segment.${type}`)}
                </Button>
            }
          </SearchWrapper>

          {table[type]}
        </WhiteWrapper>
    </div>
  )
}

export default Segment
